import type { ExteriorMaterial } from "building-types/materials/exteriorMaterialTypes";
import type { InchesSquared } from "common/types/nominalNumbersTypes";

export enum WallAreaType {
  EXTERIOR_WALL,
  INTERIOR_WALL,
  GARAGE_WALL,
}

export interface TraversedInteriorWall {
  wallType: WallAreaType.INTERIOR_WALL | WallAreaType.GARAGE_WALL;
  area: InchesSquared;
  detail?: string;
}

export interface TraversedExteriorWall {
  wallType: WallAreaType.EXTERIOR_WALL;
  area: InchesSquared;
  exteriorMaterial: ExteriorMaterial;
  detail?: string;
}

export type TraversedWall = TraversedInteriorWall | TraversedExteriorWall;
